import React from 'react';
import PropTypes from 'prop-types';
import InputField from './InputField';
import DropdownField from './DropdownField';
import UnknownField from './UnknownField';

// TODO this has the same name as the typical Form Fields
// Can they be merged? More likely, this should be renamed

const propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  edit: PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.string.isRequired,
};
const defaultProps = {
  edit: false,
  name: '',
};

export const TEXT_FIELD = 'TEXT_FIELD';
export const DROPDOWN_FIELD = 'DROPDOWN_FIELD';


/* A custom form field
 * Note, when using this component it is required to be placed
 * inside a form!
 */
function FormField(props) {
  const { type } = props;

  switch (type) {
    case TEXT_FIELD:
      return (<InputField {...props} />);
    case DROPDOWN_FIELD:
      return (<DropdownField {...props} />);
    default:
      return (<UnknownField {...props} />);
  }
}

FormField.propTypes = propTypes;
FormField.defaultProps = defaultProps;
export default FormField;
